const height = () => {

  const $height = Array.prototype.slice.call(
    document.querySelectorAll('.u-height'),
    0,
  );

  if ($height.length > 0) {
    $height.forEach(el => {
      const eHeight =  el.offsetHeight;
      el.style.setProperty('--u-elment-height', eHeight + 'px');
    });
  }
}

window.addEventListener('DOMContentLoaded', height);
window.addEventListener('resize',height);
